import React from 'react';
import Desktop from '../views/desktop/main.c';
import Tablet from '../views/tablet/main.c';
import Mobile from '../views/mobile/main.c';
import '../less';

export default function template() {
    const {isBlack, isHomePage, showDownloadApp} = this.props,
    props = {
        ...this.props,
        active: this._getActive(),
        activeSub: this._getSubActive(),
        navigate: this.navigate,
        rentier_rate: this.state.rentier_rate
    },
    { isMobile, isTablet, isDesktop } = this.state;

    return (
        <div className={`module-header ${isHomePage ? 'home-page' : ''} ${isBlack ? 'black' : ''} ${showDownloadApp ? 'show-download-app' : ''}`}>
          {isMobile && <Mobile {...props} />}
          {isTablet && <Tablet {...props} />}
          {isDesktop && <Desktop {...props} />}
        </div>
    );
}
